import { render, staticRenderFns } from "./Template-00.vue?vue&type=template&id=c9ba2bf6&"
import script from "./Template-00.vue?vue&type=script&lang=js&"
export * from "./Template-00.vue?vue&type=script&lang=js&"
import style0 from "./Template-00.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports